import { sortOptionsConfig } from '@atlassian/mpac-primitives';
function convertQueryParamsToSelectedOptions(queryString) {
  const selectedOptions = {};
  const queryParams = new URLSearchParams(queryString);
  for (const [key, value] of queryParams) {
    if (selectedOptions[key]) {
      selectedOptions[key].push(value);
    } else {
      selectedOptions[key] = [value];
    }
  }
  return selectedOptions;
}
export function getSelectedFiltersUrl(filterOptions, selectedOptions, search) {
  const selectedQueryParams = {};
  for (const key in selectedOptions) {
    if (selectedOptions[key]) {
      selectedQueryParams[key] = selectedOptions[key].map(option => option.id);
    }
  }
  const existingParams = new URLSearchParams(search);
  Object.keys(filterOptions).forEach(filterId => {
    existingParams.delete(filterId);
    if (filterId in selectedQueryParams) {
      selectedQueryParams[filterId].forEach(value => {
        existingParams.append(filterId, value);
      });
    }
  });
  return existingParams.toString();
}
export function getFilterOptionsFromUrl(_ref) {
  let {
    filterOptions,
    search
  } = _ref;
  const selectedQueryFilters = convertQueryParamsToSelectedOptions(search);
  const selectedOptions = {};
  for (const key in selectedQueryFilters) {
    if (Object.hasOwnProperty.call(filterOptions, key)) {
      selectedOptions[key] = filterOptions[key].filter(option => selectedQueryFilters[key].includes(option.id));
    }
  }
  return selectedOptions;
}
export function removeQueryParam(existingQueryString, key) {
  const existingParams = new URLSearchParams(existingQueryString);
  existingParams.delete(key);
  return existingParams.toString();
}

// get the sort option from the selected sort key
export const getSortFilter = selectedSortKey => {
  return sortOptionsConfig.find(option => option.value === selectedSortKey);
};